import React from "react";
import { JsonView, allExpanded, defaultStyles } from "react-json-view-lite";
import {
  DatePicker,
  Select,
  Button,
  Skeleton,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { s3AutomationPrivate } from "../../../utils/aws";
import { getFileFromS3, convertUnit8ArrayToJson } from "../../../utils/helpers";
import { logEndpoints } from "../../../utils/loggingService";
import "./LogViewer.css";
import "react-json-view-lite/dist/index.css";

export default class LogViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logData: [],
      selectedDate: moment(new Date()).format("MM/DD/YYYY"),
      selectedLog: "media/automation/logs/batch_reports/",
      logList: logEndpoints.reduce((acc, item) => {
        if (!acc.some((log) => log.value === item.parentFolder)) {
          acc.push({ value: item.parentFolder, label: item.dropdownLabel, dateFormat: item.dateFormat });
        }
        return acc;
      }, []),
      loading: false,
      jsonViewerStyle: {
        ...defaultStyles,
        container: "LogViewer__Styles__Container",
        label: "LogViewer__Styles__Label",
        stringValue: "LogViewer__Styles__StringValue",
        basicChildStyle: "LogViewer__Styles__basicChildStyle",
      },
    };
  }

  componentDidMount() {
    this.apiGetData();
  }

  getDateObj = (date) => {
    const dateSplit = date.split("/");
    const obj = {
      year: dateSplit[2],
      month: dateSplit[0],
      day: dateSplit[1],
    };
    return obj;
  }

  apiGetData = async () => {
    this.setState({ loading: true }, async () => {
      const { selectedDate, selectedLog, logList } = this.state;
      const { year, day, month } = this.getDateObj(selectedDate);

      let key = `${selectedLog}${year}/${month}/${day}.json`;
      const dateFormat = logList.find((item) => item.value === selectedLog).dateFormat;
      if (dateFormat === "YYYY-MM") {
        key = `${selectedLog}${year}-${month}.json`;
      }
      const s3Bucket = s3AutomationPrivate;
      const resp = await getFileFromS3(key, s3Bucket, false);
      if (resp.success) {
        let data = convertUnit8ArrayToJson(resp.data);
        if (dateFormat === "YYYY-MM") {
          const targetDate = `${month}/${day}`;
          data = data.filter((obj) => {
            const time = Object.keys(obj)[0];
            return time.includes(targetDate) || obj?.time?.includes(targetDate);
          });
        }
        this.setState({ logData: data, loading: false });
      } else {
        this.setState({ logData: [], loading: false });
      }
    });
  };

  selectOption = (text) => {
    this.setState({ selectedLog: text }, () => this.apiGetData());
  };

  onSelectLogDate = (e) => {
    const date = moment(e.$d).format("MM/DD/YYYY");
    this.setState({ selectedDate: date }, () => this.apiGetData());
  }

  downloadLog = () => {
    const { logData, selectedDate, selectedLog } = this.state;
    if (Object.keys(logData).length === 0) {
      toast.warn("No data available");
      return;
    }
    const { year, day, month } = this.getDateObj(selectedDate);
    const json = JSON.stringify(logData, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    const prefix = selectedLog.includes("send_reports/") ? "send-reports" : "batch-reports";
    const filename = `${prefix}-${year}-${month}-${day}.json`;
    a.download = filename;

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
  }

  render() {
    const {
      logData,
      selectedDate,
      selectedLog,
      logList,
      loading,
      jsonViewerStyle,
    } = this.state;

    return (
      <div className="LogViewerContainer">
        <div className="LogViewer__Topbar">
          <DatePicker
            showToday
            allowClear={false}
            className="LogViewer__Date"
            format="MM/DD/YYYY"
            placeholder="mm/dd/yyyy"
            defaultValue={(selectedDate === "" || selectedDate === "Invalid date") ? "" : dayjs(selectedDate)}
            onChange={(e) => this.onSelectLogDate(e)}
          />
          <Select
            showSearch
            className="LogViewer__Select"
            value={selectedLog}
            options={logList}
            onSelect={(text) => this.selectOption(text)}
          />
          <Button
            type="primary"
            onClick={() => this.downloadLog()}
          >
            Download
          </Button>
        </div>
        <div className="LogViewer__Count">
          Total items:
          {" "}
          {logData.length}
        </div>
        {!loading && (
        <JsonView
          data={logData}
          shouldExpandNode={allExpanded}
          style={jsonViewerStyle}
        />
        )}
        {loading && (<Skeleton.Input active />)}
      </div>
    );
  }
}
